import api from '@/services/api/api';
import axios from "axios";
import store from '@/store'

const initialState = () => ({
  country: {
    "pais_id": "AR",
    "idioma_id": "es",
    "moneda_id": "ARS",
    "region_defecto_id": 3433955,
    "sucursal_defecto_id": 1,
    "nombre": "Argentina",
    "zona_horaria": "UTC-03:00",
    "multiplicador": 1,
    "descuento_global": 40,
    "default_timezone_id": "America/Argentina/Buenos_Aires",
    "moneda": {
      "moneda_id": "ARS",
      "nombre": "Peso Argentino"
    }
  },
  region: {
    "region_id": 3435907,
    "region_iso_id": "AR-B",
    "pais_id": "AR",
    "nombre": "Buenos Aires",
    "latitud": -36,
    "longitud": -60
  },
  userCalendars: [],
  userCalendarsGrouped: [],
  teacherGrouped: []
});

export default {
  namespaced: true,
  state: initialState(),
  actions: {
    async fetch({ state }) {
      try{
        const response = await axios.get(process.env.VUE_APP_EDUCACIONIT_API_SERVER + "init?include=pais,region", {});

        state.country = response.data.pais;
        state.region = response.data.region;
      } catch(e){
        console.error(e);
      }
    },
    async fetchUserCalendars({ commit, state, rootState }){
      const userId = parseInt(rootState.Auth.user.userId);

      const options = {
        headers:{
          'Authorization': `Bearer ${await store.state.AuthFirebase.auth.currentUser?.getIdToken()}`,
          'X-Hollow-Man': localStorage.getItem('client_init_ts') ?? '',
          'Content-Type': 'application/json'
        }
      };

      try {
        const params = {
          contacto_id: userId,
          include: 'curso,clases,profesor,calendario_detalle',
          attributes: 'calendario_id,curso_id,pendiente,anulado,turno,discord_channel_id,discord_deleted_at,contactos_calendarios.paquete_id,contactos_calendarios.calendario_recursa_id,contactos_calendarios.paquete_calendario_id'
        };

        const calendarsPromise = axios.get(
          process.env.VUE_APP_EDUCACIONIT_API_SERVER + 'alumni/calendarios',
          {
            ...options,
            params
          }
        );

        const statsPromise = axios.get(
            process.env.VUE_APP_EDUCACIONIT_API_SERVER + `alumni/contactos/${userId}/exams/stats`,
            options
          )
          .then(response => response.data?.data ?? [])
          .catch(() => []);

        const [calResponse, statsArray] =
          await Promise.all([calendarsPromise, statsPromise]);

        const statsByCursoId = new Map();

        statsArray.forEach(({ curso_id, total, approved }) => {
          if (!curso_id) return;

          statsByCursoId.set(curso_id, {
            total,
            approved,
            progress: Math.round((approved / total) * 100)
          });
        })

        const getStatsForCurso = (cursoId) => {
          return statsByCursoId.get(cursoId) || null;
        };

        // helper
        const getStart = item => {
          if (!item || !item.calendario_detalle || !item.calendario_detalle.fecha_inicio) {
            return 0;
          }
          return Date.parse(item.calendario_detalle.fecha_inicio);
        };

        const rawTeacherItems = calResponse.data.data.filter(item => {
          return (
            userId === item.profesor?.contacto?.contacto_id ||
            item.calendarios_permisos.some(
              p => p.rol_id === 39 && p.alumni_estado_id === 'A'
            )
          );
        });

        const teacherCounts = rawTeacherItems.reduce((acc, item) => {
          acc[item.curso_id] = (acc[item.curso_id] || 0) + 1;
          return acc;
        }, {});

        const teacherMap = new Map(); // <curso_id, calendario>
        const teacherList = [];
        const studentList = [];

        // In this way, all calendars belonging to the same course where a user is a Teacher
        // are grouped together, so the dashboard card is the one with the most current calendar_id
        calResponse.data.data.forEach(item => {
          item.contactos_calendarios.forEach((cc) => {
            if(!cc.paquete_calendario_id) return

            const packageCalendar = calResponse.data.data.find(cal => {
              return cal.calendario_id === cc.paquete_calendario_id
            })

            if(packageCalendar?.calendarios_permisos.some(p => p.alumni_estado_id === 'B')){
              item.calendarios_permisos.forEach(cp => {
                cp.alumni_estado_id = 'B'
              })
            }
          })

          const is_teacher =
            userId === item.profesor?.contacto?.contacto_id ||
            item.calendarios_permisos.some(
              p => p.rol_id === 39 && p.alumni_estado_id === 'A'
            );

          item.curso.stats = getStatsForCurso(item.curso_id)

          const calendar = { ...item, is_teacher };

          if (is_teacher) {
            teacherList.push(calendar);
            const count = teacherCounts[item.curso_id] || 0;

            // Only add to map if:
            //  - Is NOT pending
            //  - Is pending and is the only one
            if (!calendar.pendiente || count === 1) {
              const prev = teacherMap.get(item.curso_id);
              if (!prev || getStart(calendar) > getStart(prev)) {
                teacherMap.set(item.curso_id, calendar);
              }
            }
          } else {
            if(item.calendarios_permisos.some(c => c.alumni_estado_id === 'A')){
              studentList.push(calendar);
            }
          }
        });

        const teacherGrouped = [...teacherMap.values()].sort((a, b) => getStart(b) - getStart(a))

        const groupedCalendars = [
          ...teacherGrouped,
          ...studentList.sort((a, b) => getStart(b) - getStart(a))
        ];

        const calendars = [
          ...teacherList.sort((a, b) => getStart(b) - getStart(a)),
          ...studentList.sort((a, b) => getStart(b) - getStart(a))
        ];

        state.teacherGrouped = teacherGrouped;
        state.userCalendarsGrouped = groupedCalendars;
        state.userCalendars = calendars;
      } catch (error) {
        if (error.response?.status === 404) {
          state.userCalendars = [];
          return error.response;
        }
        return error.response;
      }
    },
  },
  getters: {
    country: (state) => state.country,
    region: (state) => state.region,
    userCalendars: (state) => state.userCalendars,
    userCalendarsGrouped: (state) => state.userCalendarsGrouped,
    teacherGrouped: (state) => state.teacherGrouped
  },
};
